import { Component, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { InterfaceCheckPoint } from 'app/models/check-point.model';
import { InterfaceJob } from 'app/models/job.model';
import { InterfaceProcedure } from 'app/models/procedure.model';
import { EmployeeService } from 'app/services/employee.service';
import { take } from 'rxjs/operators';
import { CreateFunctionsComponent } from '../create-functions/create-functions.component';
import { CreateJobComponent } from '../create-job/create-job.component';
import { CreateProcedureComponent } from '../create-procedure/create-procedure.component';
import { CreateCouncilComponent } from '../create-council/create-council.component';
import { CreateReportComponent } from '../create-report/create-report.component';

@Component({
  selector: 'app-jobs-table',
  templateUrl: './jobs-table.component.html',
  styleUrls: ['./jobs-table.component.scss']
})
export class JobsTableComponent implements OnInit {

  jobs: InterfaceJob[] = [];
  selectedJob: InterfaceJob;
  councils: any[] = [];
  reports: any[] = [];
  checkPoints: InterfaceCheckPoint[] = [];
  procedures: InterfaceProcedure[] = [];

  constructor(
    public modal: NgbModal,
    protected employeeService: EmployeeService
  ) { }

  ngOnInit(): void {
    this.getJobs();
  }

  getJobs(): void {
    this.employeeService.getJobs().pipe(take(1)).subscribe((result: InterfaceJob[]) => {
      this.jobs = result;
    }, (error: any) => {
      console.error(error);
    });
  }

  resetJobs(): void {
    this.jobs = [];
    this.getJobs();
  }

  addJob(): void {
    const modalRef = this.modal.open(CreateJobComponent, {
      centered: true,
      backdrop: "static",
      size: "lg",
      animation: true
    });
    modalRef.result.then(() => {
      this.resetJobs();
    })
  }

  selectJob(job: InterfaceJob): void {
    this.selectedJob = job;
    this.checkPoints = [];
    this.procedures = [];
    this.getCheckPoints();
    this.getProcedures();
    this.getCouncils();
    this.getReports();
  }

  getCouncils(): void {
    this.employeeService.getCouncils(this.selectedJob.id).pipe(take(1)).subscribe((result: any) => {
      this.councils = result;
    }, (error: any) => {
      console.error(error);
    });
  }

  getReports(): void {
    this.employeeService.getReports(this.selectedJob.id).pipe(take(1)).subscribe((result: any) => {
      this.reports = result;
    }, (error: any) => {
      console.error(error);
    });
  }

  getCheckPoints(): void {
    this.employeeService.getCheckPoints(this.selectedJob.id).pipe(take(1)).subscribe((result: InterfaceCheckPoint[]) => {
      this.checkPoints = result;
    }, (error: any) => {
      console.error(error);
    });
  }

  resetCheckPoints(): void {
    this.checkPoints = [];
    this.getCheckPoints();
  }

  createCheckPoint(): void {
    const modalRef = this.modal.open(CreateFunctionsComponent, {
      centered: true,
      backdrop: "static",
      size: "lg",
      animation: true
    });
    modalRef.componentInstance.job = this.selectedJob;
    modalRef.result.then(() => {
      this.resetCheckPoints();
    });
  }

  downloadFile(url: string): void {
    window.open(url);
  }

  createProcedure(): void {
    const modalRef = this.modal.open(CreateProcedureComponent, {
      centered: true,
      backdrop: "static",
      size: "lg",
      animation: true
    });
    modalRef.componentInstance.job = this.selectedJob;
    modalRef.result.then(() => {
      this.resetProcedures();
    });
  }

  resetProcedures(): void {
    this.procedures = [];
    this.getProcedures();
  }

  getProcedures(): void {
    this.employeeService.getProcedures(this.selectedJob.id).pipe(take(1)).subscribe((result: InterfaceProcedure[]) => {
      this.procedures = result;
    }, (error: any) => {
      console.error(error);
    });
  }

  createCouncil(): void {
    const modalRef = this.modal.open(CreateCouncilComponent, {
      centered: true,
      animation: true,
      backdrop: "static"
    });
    modalRef.componentInstance.job = this.selectedJob;
    modalRef.result.then(() => {
      this.councils = [];
      this.getCouncils();
    }).catch((error: any) => {
      console.error(error);
    });
  }

  createReport(): void {
    const modalRef = this.modal.open(CreateReportComponent, {
      centered: true,
      animation: true,
      backdrop: "static"
    });
    modalRef.componentInstance.job = this.selectedJob;
    modalRef.result.then(() => {
      this.reports = [];
      this.getReports();
    }).catch((error: any) => {
      console.error(error);
    });
  }
}
